export enum StatusesEnum {
  /** Job Status */
  pending = 'Pending',
  done = 'Done',
  completed = 'Completed',
  /** Others */
  running = 'Running',
  earlyDrop = 'Early Drop',
  late = 'Late',
  approved = 'Approved',
  scheduled = 'Scheduled',
  draft = 'Draft',
  delivered = 'Delivered',
  active = 'Active',
  inactive = 'Inactive',
}

export type StatusesType =
  | 'running'
  | 'done'
  | 'earlyDrop'
  | 'late'
  | 'pending'
  | 'approved'
  | 'scheduled'
  | 'completed'
  | 'draft'
  | 'delivered'
  | 'active'
  | 'inactive';
